export { default } from './SimilarTitlesInfo';



// WEBPACK FOOTER //
// ./app/components/shelves/ShelfListItem/SimilarTitlesInfo/index.js